import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import { device } from '../models/device'
import { theme } from '../models/theme'
import { RegularContentDiv, RegularPaddinglessContentDiv, ContentSection, FullPageContentSection, FullPageMarginlessContentSectionMobile, StyledPageDiv, StyledSpacerDiv, FullPageMarginlessContentSection, GradientCoverTopBottomAbsolute } from '../general/GeneralStyles'
import placeholder from '../images/landing/placeholder_faceswap.png'

import PillButton from '../components/PillButton'

import pindubTrailer from '../images/pindub/pindubscreenrecording_rescaled_screen.mp4';
import pindubTrailerThumb from '../images/pindub/pindubscreenrecording_rescaled_screen.jpg';
import pindubBackground from '../images/pindub/pindubBackground.png';
import pindubPhoneUnderlay from '../images/pindub/phone-black.png';

import ContentOverVideo from '../components/ContentOverVideo'
import { Helmet } from 'react-helmet-async'
import YoutubePopup from '../components/YoutubePopup'
import { Link } from 'react-router-dom'
import MinimalVideo from '../components/MinimalVideo'
import { CenterDiv, CoverTextContainer, CoverTextContainerLeft, FullViewContentCoverLeft, FullViewImageContainer } from './Home'
import VideoBackgroundDiv from '../components/VideoBackgroundDiv'
import ImageBackgroundDiv from '../components/ImageBackgroundDiv'


export const FullTopFlex = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    align-items: center;
`

export const TitleOverDiv = styled.div`
top:0;
    position: absolute;

    h1 {
        position: relative;
       font-size: 2rem;
    }

    @media ${device.mobile} {
        position: relative;
    }
`

export const BottomAlignedSection = styled.div`
    height: 100%;
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media ${device.mobile} {
        width: 90%;
    }
`

export const BottomAlignedMarginSection = styled.div`
    height: 100%;
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: start;
    z-index: 10;
    background: none;
`

export const BottomRowSection = styled.div`
    height: auto;
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2rem 0 2rem 0;
    padding: 1rem;

    background: ${props => props.theme.panelTransparentDark};
    backdrop-filter: blur(10px);
    border-radius: ${props => props.theme.borderRadius};

    h1, h2, p {
        text-align: center;
        margin-block-start: 0;
        margin-block-end: 0;
        margin-block: 0.5rem;
        @media ${device.mobile} {
            text-shadow: ${props => props.theme.panelDark} 0 0 8rem;
        }
    }

    h2 {
        color: ${props => props.theme.accent};
        font-weight: 400;
    }

    p {
        @media ${device.mobile} {
            font-size: 1rem;
        }
    }

    @media ${device.mobile} {
        flex-direction: column;
        justify-content: center;

        h1, h2, p {
            text-align: center;
        }
    }
`

const HorizFlex = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 2rem;
`

export const LeftTextRegion = styled.div`
    width: 30%;
    height: auto;

    p, h3 {
        text-align: left;
    }

    @media ${device.mobile} {
        width: 100%;
            p, h3 {
                text-align: center;
            }
    }
`
export const HoriztonalFeatureSection = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
    gap: 12px;
    padding: 2rem 48px 0 48px;

    @media ${device.mobile} {
        flex-direction: column-reverse;
    }
`

export const MarginContainerTech = styled.div`
    width: 100%;
    margin: 2rem 0 1rem 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    @media ${device.mobile} {
        justify-content: center;
    }
`

export const RightSwiperRegion = styled.div`
    width: 50%;
    height: auto;
    @media ${device.mobile} {
        width: 100%;
    }
`

export const HoriztonalSection = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 12px;
`

export const SplitViewContentCover = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: ${props => props.theme.ShadeCover};
    padding: 2rem 4rem 2rem 4rem;
    box-sizing: border-box;
    gap: 2rem;
    @media ${device.mobile} {
        padding: 0;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`


export const FullViewContentCoverRight = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    box-sizing: border-box;
`

export const VideoCover = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`

export const PhoneContainer = styled.div`
    position: relative;
    height: 100%;
    width: auto;
    @media ${device.mobile} {
        width: 100%;
    }
`

export const PhoneOverlay= styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    padding: 20% 5% 20% 5%;
    box-sizing: border-box;
`

export const ImageOverlay = styled.img`
    position: relative;
    height: 100%;
    width: auto;
    @media ${device.mobile} {
        width: 100%;
    }
`

export const VideoRegion = styled.div`
    height: 100%;
    aspect-ratio: 888/1600;
    display: block;
    border-radius: 2rem;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 2rem;
`

// export const ImageBehindDiv = styled.div`
//     position: absolute;
//     width: 100%;
//     height: ;
//     z-index: 0;
// `

// export const ImageBehind = styled.img`
//     position: relative;
//     width: 100%;
//     height: calc(100vh - 86);
//     aspect-ratio: ${props => props.aspectRatio};
//     object-fit: cover;
// `

export default function PindubWeb() {
    const [isOpenPopup, setIsOpenPopup] = useState(false);
        const [dimensions, setDimensions] = React.useState({ 
            height: window.innerHeight,
            width: window.innerWidth
          });

          useEffect(() => {
                  // for resize handling
                  function handleResize() {
                      setDimensions({
                        height: window.innerHeight ,
                        width: window.innerWidth 
                      });
                  }
          
                  window.addEventListener('resize', handleResize);
                  handleResize();
          


          
                  return () => {
                      window.removeEventListener('resize', handleResize);          
                  }
              }, []);

    return(
        <StyledPageDiv>
            <Helmet>
                <title>Pindub.ai</title>
                <meta name="description" content="Redub, Resync and Reimagine with Pindub.ai is the most advanced AI lip sync solution for video personalization, visual dubbing, and translation." key="desc" />
                <meta property="og:title" content="Pindub.ai" />
                <meta
                property="og:description"
                content="Redub, Resync and Reimagine with Pindub.ai is the most advanced AI lip sync solution for video personalization, visual dubbing, and translation."
                />
            </Helmet>
            <YoutubePopup youtubeLink='https://www.youtube.com/embed/SUYcTjre0Vg?si=WGvQsd-R61mnpxpM' onClose={() => {setIsOpenPopup(false)}} isOpen={isOpenPopup}/>
            <StyledSpacerDiv/>
            <RegularPaddinglessContentDiv>
            <FullPageMarginlessContentSection id='pindubSection'>
                        <FullViewImageContainer>
                        <ImageBackgroundDiv source={pindubBackground} aspectRatio={"16/9"} brightness={0.5}>
                                <GradientCoverTopBottomAbsolute/>
                                <SplitViewContentCover>
                                <FullViewContentCoverLeft>
                                    <CoverTextContainerLeft>
                                        <h1>
                                            Pindub.ai
                                        </h1>
                                        <p>
                                        <a href='https://pindub.ai' target="_blank">Pindub.ai</a> brings Pinscreen’s Hollywood-grade visual dubbing technology to everyone. Instantly sync lip movements to any audio or script, or translate your videos into 25+ languages with photorealistic precision. Perfect for creators, educators, marketers, and filmmakers looking to localize or personalize content at scale.
                                        </p>
                                    </CoverTextContainerLeft>
                                        <a href='https://pindub.ai' target="_blank">
                                            <PillButton baseBackground={theme.buttonHoverTransparent} baseColor={theme.textLight} hoverBackground={theme.buttonHover} hoverColor={theme.textLight} value={"Try Pindub"}/>
                                        </a>
                                    </FullViewContentCoverLeft>
                                    <FullViewContentCoverRight>
                                        <VideoCover>
                                            <PhoneContainer>
                                                <ImageOverlay src={pindubPhoneUnderlay}/>
                                                                                                    <PhoneOverlay>
                                                <MinimalVideo looping={true} playing={true} aspectRatio={"888/1600"} source={pindubTrailer} previewImage={pindubTrailerThumb}/>
                                                </PhoneOverlay>
                                            </PhoneContainer>
                                        </VideoCover>
                                    </FullViewContentCoverRight>
                                </SplitViewContentCover>
                            </ImageBackgroundDiv>
                        </FullViewImageContainer>
                    </FullPageMarginlessContentSection>
            </RegularPaddinglessContentDiv>
        </StyledPageDiv>
    )
}